module.exports = __webpack_public_path__ + "static/media/warning.5288cee0.svg";